import { render, staticRenderFns } from "./V2ProfileSocial.vue?vue&type=template&id=41f1086f&scoped=true&"
import script from "./V2ProfileSocial.vue?vue&type=script&lang=js&"
export * from "./V2ProfileSocial.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileSocial.vue?vue&type=style&index=0&id=41f1086f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1086f",
  null
  
)

export default component.exports